import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const sell_AugmontApi = createAsyncThunk("sell_Augmont", async () => {
  const response = await axiosInstance.get("/sell_Augmont");
  return response.data;
});

const sell_AugmontSlice = createSlice({
  name: "sell_Augmont",
  initialState: {
    sell_Augmont: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sell_AugmontApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(sell_AugmontApi.fulfilled, (state, action) => {
        state.sell_Augmont = action.payload;
        state.loading = false;
      })
      .addCase(sell_AugmontApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default sell_AugmontSlice.reducer;
